import { useState } from "react";
import { useMutation } from "@apollo/client";
import { UPDATE_CLOSE_JOB_MUTATION } from "../queries";
import { JobPostCloseFormInput } from "../close/types";

export const useJobPostCloseForm = (jobPostId: string) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [updateCloseJob] = useMutation(UPDATE_CLOSE_JOB_MUTATION);

  const handleSubmit = async (data: Partial<JobPostCloseFormInput>) => {
    setIsSubmitting(true);
    try {
      const input: any = {
        id: jobPostId,
        status: data.hiringStatus,
        sendEmployerSurvey: data.sendEmployerSurvey
      };

      // Only include fields that are provided in the partial update
      if (data.careerConsultantVisited !== undefined) {
        input.consultantVisitedFacility = data.careerConsultantVisited;
      }
      if (data.isPgaFacilityConversion !== undefined) {
        input.isFacilityConversion = data.isPgaFacilityConversion;
      }
      if (data.isPgaJobPlacementConversion !== undefined) {
        input.isPlacementConversion = data.isPgaJobPlacementConversion;
      }
      if (data.hireIsPgaPro !== undefined) {
        input.isHireePgaPro = data.hireIsPgaPro;
      }
      if (data.isNetNewPosition !== undefined) {
        input.isNetNewPosition = data.isNetNewPosition;
      }
      if (data.hireCompensationAmount !== undefined) {
        input.hiredCompensationAmount =
          data.hiringStatus === "Filled" && input.hiredCompensationAmount !== null
            ? parseFloat(data.hireCompensationAmount!)
            : null;
      }
      if (data.hireCompensationSchedule !== undefined) {
        input.hiredCompensationSchedule =
          data.hiringStatus === "Filled" && data.hireCompensationSchedule !== "none"
            ? data.hireCompensationSchedule
            : null;
      }
      if (data.previousCompensation !== undefined) {
        input.previousCompensationAmount = Number(data.previousCompensation) || null;
      }
      if (data.notes !== undefined) {
        input.closeComments = data.notes;
      }

      // Always include hireeId or null as appropriate
      if (data.employeeData) {
        input.hireeId = data.employeeData.id;
      } else if (data.hireeId !== undefined) {
        input.hireeId = data.hireeId || null;
      }

      const result = await updateCloseJob({
        variables: { input }
      });
      return result;
    } catch (error) {
      throw error;
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    isSubmitting,
    handleSubmit
  };
};
